<ng-template
	[ngIf]="loading === true"
	[ngIfElse]="Content">
	<div class="ui-g-12 no-horizontal-padding text-center">
		<i class="loading-spinner theme-color fa fa-fw fa-spin fa-spinner">
		</i>
	</div>
</ng-template>

<ng-template #Content>
	<div class="ui-g-12 no-padding p-inputgroup">
		<span class="p-inputgroup-addon">
			Go to
		</span>
		<p-dropdown
			[options]="searchTypes"
			placeholder="Select Category"
			appendTo="body"
			[disabled]="searchTypes.length === 1"
			[(ngModel)]="selectedType"
			(onChange)="updateControls()">
		</p-dropdown>
		<input type="text"
			pInputText
			[placeholder]="searchPlaceholder"
			[(ngModel)]="searchText"
			(input)="updateControls()"
			(keydown.enter)="navigateToEntity()"/>
		<button type="button"
			pButton
			[disabled]="disabled"
			styleClass="p-button-primary"
			(click)="navigateToEntity()">
			Go
		</button>
	</div>
</ng-template>